import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from 'app/common/form/Adornment';

export default class FormSelectField extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue || (props.nullable ? null : '')
    };
  }

  handleChange = (event) => {
    let value = event.target.value;

    if (
      this.props.nullable &&
      typeof this.props.nullValue !== 'undefined' &&
      value === null
    ) {
      value = this.props.nullValue;
    }

    const ev = {
      target: {
        name: this.props.name,
        value: value,
        type: 'text'
      }
    };

    this.props.onChange(ev);
    this.setState({ value });
  };

  toOption = (option) => {
    const { value, label = value } =
      typeof option === 'string' ? { value: option } : option;
    return (
      <MenuItem key={value} value={value}>
        {label}
      </MenuItem>
    );
  };

  render() {
    const {
      nullable,
      nullValue, // eslint-disable-line no-unused-vars
      options,
      children,
      onChange, // eslint-disable-line no-unused-vars
      value, // eslint-disable-line no-unused-vars
      defaultValue, // eslint-disable-line no-unused-vars
      InputProps = {},
      startAdornment,
      endAdornment,
      ...props
    } = this.props;

    const nextInputProps = { ...InputProps };

    if (startAdornment) {
      nextInputProps.startAdornment =
        typeof startAdornment === 'string' ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : (
          startAdornment
        );
    }

    if (endAdornment) {
      nextInputProps.endAdornment =
        typeof endAdornment === 'string' ? (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ) : (
          endAdornment
        );
    }

    return (
      <TextField
        select
        style={{ marginBottom: 24 }}
        InputLabelProps={{ shrink: true }}
        value={this.state.value}
        onChange={this.handleChange}
        InputProps={nextInputProps}
        {...props}
      >
        {nullable ? <MenuItem value=""> </MenuItem> : null}
        {children || options.map(this.toOption)}
      </TextField>
    );
  }
}